import React from 'react';
import styled from 'styled-components';
import { TASK_LIST_OPTIONS_DEL_PREFIX, TASK_LIST_OPTIONS_DETAILS_PREFIX, TASK_LIST_OPTIONS_DUPLICATE_PREFIX } from '../../../utils/constants';
import { gray1, red7 } from '../../colours';
import { uiTextMedium } from '../../typography';

import TaskOperationDropdownItem from './TaskOperationDropdownItem';

const Container = styled.div`
  position: absolute;
  padding: 8px;
  background-color: ${gray1};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  // the translate x value should be the width of this element 
  // subtract the width of dropdown button
  // TODO calculate this value programmatically
  transform: translate(-143px, 6px);
  z-index: 25;
`;

const Text = styled.span`
  ${uiTextMedium}
  width: 138px;
`;

const RedText = styled.span`
  color: ${red7};
`;

interface Props {
  id?: string,
  onDeleteClick: () => void,
  onDuplicateClick: () => void,
  onGoToMeetingClick: () => void,
  onTaskDetailsClick: () => void,
  disableGoToMeeting: boolean,
}

const TaskOperationDropdownOptions = ({
  id, onTaskDetailsClick, onDeleteClick, onDuplicateClick, onGoToMeetingClick, disableGoToMeeting,
}: Props) => (
  <Container>
    <TaskOperationDropdownItem
      id={TASK_LIST_OPTIONS_DETAILS_PREFIX + id}
      onClick={onTaskDetailsClick}
    >
      <Text>
        View details
      </Text>
    </TaskOperationDropdownItem>
    <TaskOperationDropdownItem
      id={TASK_LIST_OPTIONS_DUPLICATE_PREFIX + id}
      onClick={onDuplicateClick}
    >
      <Text>
        Duplicate
      </Text>
    </TaskOperationDropdownItem>
    {!disableGoToMeeting && (
      <TaskOperationDropdownItem onClick={onGoToMeetingClick}>
        <Text>
          Go to meeting
        </Text>
      </TaskOperationDropdownItem>
    )}
    <TaskOperationDropdownItem id={TASK_LIST_OPTIONS_DEL_PREFIX + id} onClick={onDeleteClick}>
      <Text>
        <RedText>
          Delete
        </RedText>
      </Text>
    </TaskOperationDropdownItem>
  </Container>
);

TaskOperationDropdownOptions.defaultProps = {
  id: '',
};

export default TaskOperationDropdownOptions;
